import home from '@/view/home';
import SEO from './SEO.json';
const basePath = window.appConfig.VUE_APP_PATH;

const routes = [
  // {
  //   path: basePath,
  //   redirect: `${basePath}home`, // 默认显示
  // },
  {
    path: `${basePath}`,
    name: 'home',
    meta: { ...SEO.home, isTrack: true },
    component: home,
  },
  {
    path: `${basePath}saas`,
    name: 'saas',
    meta: { ...SEO.saas, isTrack: true },
    component: () => import('@/view/saas'),
  },
  {
    path: `${basePath}open`,
    name: 'open',
    meta: { ...SEO.open, isTrack: true },
    component: () => import('@/view/open'),
  },
  {
    // 生态合作
    path: `${basePath}partner`,
    name: 'partner',
    redirect: `${basePath}partner/detail`,
    children: [
      {
        path: 'detail',
        meta: { ...SEO.partner, isTrack: true },
        component: () => import('@/view/partner/detail'),
      },
      {
        path: 'form',
        meta: { ...SEO.joinPartner, minBanner: true, isTrack: true },
        component: () => import('@/view/partner/info'),
      },
    ],
  },
  {
    // 笔记登录
    path: `${basePath}note`,
    meta: {
      title: '签字登录',
      isTrack: true,
      name: 'note',
      style:
        'background: #152231; color: #fff; border-bottom: 1px solid #182839; box-shadow: none',
    },
    component: () => import('@/view/note'),
  },
  {
    // 文件验签
    path: `${basePath}product`,
    redirect: `${basePath}product/checkfile`,
    children: [
      {
        path: 'checkfile',
        meta: { ...SEO.DocVerification, minBanner: true, isTrack: true },
        component: () => import('@/view/product/checkfile.vue'),
      },
      {
        path: 'result/:sm3?',
        component: () => import('@/view/product/result'),
        meta: { ...SEO.DocVerification, isTrack: true },
      },
    ],
  },
  {
    path: `${basePath}about`,
    redirect: `${basePath}about/us`,
    children: [
      {
        path: 'us',
        meta: { ...SEO.aboutUs, minBanner: true, isTrack: true },
        component: () => import('@/view/about/us'),
      },
      {
        path: 'acade',
        meta: { ...SEO.acade, minBanner: true, isTrack: true },
        component: () => import('@/view/about/acade'),
      },
    ],
  },
  // {
  //   // 电子合同
  //   path: `${basePath}econtract`,
  //   meta: { ...SEO.eContract, minBanner: true, isTrack: true },
  //   component: () => import('@/view/econtract'),
  // },
  {
    // 新闻中心
    path: `${basePath}news`,
    redirect: `${basePath}news/list`,
    children: [
      {
        // 新闻列表
        path: 'list',
        meta: { ...SEO.newsInfor, minBanner: true, isTrack: true },
        component: () => import('@/view/news'),
      },
      {
        // 新闻详情
        path: 'detail',
        meta: { ...SEO.newsDetail },
        component: () => import('@/view/news/detail.vue'),
      },
    ],
  },
  {
    // 行业应用
    path: `${basePath}trade`,
    redirect: `${basePath}trade/jiaoguan`,
    children: [
      {
        path: 'jiaoguan',
        meta: { ...SEO.tradeGongan },
        component: () => import('@/view/trade/jiaoguan'),
      },
      {
        path: 'jianwu',
        meta: { ...SEO.tradeJiancha },
        component: () => import('@/view/trade/jianwu'),
      },
      {
        path: 'zhengwu',
        meta: { ...SEO.tradeShuzi },
        component: () => import('@/view/trade/zhengwu'),
      },
    ],
  },
  {
    // 大屏签到
    path: `${basePath}/signIn`,
    children: [
      {
        path: '',
        meta: { title: '大屏签到', name: 'signIn', isTrack: true },
        component: () => import('@/view/signIn'),
      },
      {
        path: `test`,
        meta: { title: '大屏签到-体验说明', name: 'signIn', isTrack: true },
        component: () => import('@/view/signIn/test.vue'),
      },
    ],
  },
  {
    // 帮助中心
    path: `${basePath}help`,
    meta: { ...SEO.service, minBanner: true },
    component: () => import('@/view/help'),
  },
  {
    path: `${basePath}404`,
    meta: { title: 'Page not found' },
    component: () => import('./notfind.vue'),
  },
  {
    path: `${basePath}putin`,
    meta: { title: '亲笔签', notUrl: true, isTrack: true },
    component: () => import('@/view/putin'),
  },
  {
    path: `${basePath}eputin`,
    meta: { title: '亲笔签', name: 'eputin', isTrack: true },
    component: () => import('@/view/eputin'),
  },
  // 解决方案
  {
    path: `${basePath}solutions`,
    redirect: `${basePath}solutions/education`,
    children: [
      {
        path: 'education',
        meta: { title: '教育行业解决方案', name: 'education' },
        component: () => import('@/view/solutions/education'),
      },
      {
        path: 'finance',
        meta: { title: '金融行业解决方案', name: 'finance' },
        component: () => import('@/view/solutions/finance'),
      },
      {
        path: 'security',
        meta: { title: '担保行业解决方案', name: 'security' },
        component: () => import('@/view/solutions/security'),
      },
      {
        path: 'hr',
        meta: { title: '人力行业解决方案', name: 'hr' },
        component: () => import('@/view/solutions/hr'),
      },
      {
        path: 'property',
        meta: { title: '地产行业解决方案', name: 'property' },
        component: () => import('@/view/solutions/property'),
      },
    ],
  },
  // 宣传页集中
  {
    path: `${basePath}leaflets`,
    redirect: `${basePath}leaflets/leaf`,
    children: [
      {
        path: 'leaf',
        meta: { title: '宣传页', name: 'leaflet' },
        component: () => import('@/view/leaflets/leaf'),
      },
    ],
  },
  {
    // 电子签名
    path: `${basePath}eSign`,
    meta: {
      title: '电子签名',
      name: 'eSign',
      style:
        'background: #152231; color: #fff; border-bottom: 1px solid #182839; box-shadow: none',
      arrowStyle: 'fill: #fff',
    },
    component: () => import('@/view/eSign'),
  },

  {
    path: `${basePath}experience`,
    children: [
      {
        path: '',
        meta: { title: '体验中心', name: 'experience', isTrack: true },
        component: () => import('@/view/experience'),
      },
      {
        path: `demopc`,
        meta: {
          title: '体验中心',
          name: 'demo',
          isTrack: true,
          customHeader: true,
        },
        component: () => import('@/view/experience/demoPc'),
      },
      {
        path: `demomobile`,
        meta: {
          title: '体验中心',
          name: 'demo',
          isTrack: true,
          customHeader: true,
        },
        component: () => import('@/view/experience/demoM'),
      },
    ],
  },
  {
    path: `${basePath}:catchAll(.*)`, // 不识别的路由跳404
    redirect: `${basePath}404`,
  },
];
export default routes;
